import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { VgasBirimDosyaBelgeService } from '../ctl-vgas-birim-dosya-belge.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: VgasBirimDosyaBelgeService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([]);

            const filterArr = [];
            if (this.service.birimKod) filterArr.push(['BirimKod', '=', this.service.birimKod]);
            if (this.service.dosyaPlanKod) filterArr.push(['DosyaPlanKod', '=', this.service.dosyaPlanKod]);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }

}
